import React, { useState } from "react";
import emailjs from "emailjs-com";

const Enquiry = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [statusMessage, setStatusMessage] = useState(""); // New state for the status message

  const toggleForm = () => {
    setIsFormOpen(!isFormOpen);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Get values from environment variables
    const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const userID = process.env.REACT_APP_EMAILJS_USER_ID;

    // Send email using EmailJS
    emailjs
      .send(
        serviceID, // Service ID from .env
        templateID, // Template ID from .env
        formData, // Form data
        userID // User ID from .env
      )
      .then(
        (response) => {
          console.log("Enquiry sent successfully!", response);
          setStatusMessage("Enquiry sent successfully!"); // Success message
        },
        (error) => {
          console.error("Error sending enquiry:", error);
          setStatusMessage("Failed to send enquiry. Please try again later."); // Error message
        }
      );

    // Reset form
    setFormData({
      name: "",
      email: "",
      phone: "",
      message: "",
    });
  };

  return (
    <>
      <div className="fixed right-0 top-1/2 transform -translate-y-1/2 z-50">
        <button
          onClick={toggleForm}
          className="bg-primary text-white px-4 py-2 shadow-lg hover:bg-secondary transition-all transform rotate-180 origin-center"
          style={{
            writingMode: "vertical-rl",
            borderBottomLeftRadius: "0.5rem",
            borderBottomRightRadius: "0.5rem",
            borderTopLeftRadius: "0.5rem",
            borderTopRightRadius: "0.5rem",
          }}
        >
          Enquire Now
        </button>
      </div>

      {/* Enquiry Form */}
      <div
        className={`fixed top-1/2 transform -translate-y-1/2 right-0 z-50 bg-white w-80 p-6 rounded-lg shadow-lg transition-transform duration-500 ${
          isFormOpen ? "translate-x-0" : "translate-x-full"
        }`}
        style={{ height: "auto" }}
      >
        <button
          onClick={toggleForm}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <h2 className="text-1xl font-bold text-primary mb-4">Enquire Now</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium">Full Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your full name"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
            />
          </div>
          <div>
            <label className="block text-gray-700 font-medium">Email ID</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
            />
          </div>
          <div>
            <label className="block text-gray-700 font-medium">
              Phone Number
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter your phone number"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
            />
          </div>
          <div>
            <label className="block text-gray-700 font-medium">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Type your message"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
              rows="4"
            ></textarea>
          </div>
          <button
            type="submit"
            className="w-full bg-primary text-white px-4 py-2 rounded-lg shadow hover:bg-secondary transition-all"
          >
            Send Enquiry
          </button>
        </form>

        {/* Display status message */}
        {statusMessage && (
          <div
            className={`mt-4 p-2 text-center ${
              statusMessage.includes("successfully")
                ? "text-green-600"
                : "text-red-600"
            }`}
          >
            {statusMessage}
          </div>
        )}
      </div>
    </>
  );
};

export default Enquiry;
